import { t } from '../i18n';

// eslint-disable-next-line no-control-regex
const ASCII_REGEX = /^[\x00-\x7F]*$/;

const validateASCII = (value: string): string => {
    if (!ASCII_REGEX.test(value)) {
        return t('ascii', { field: t('field-common') });
    }
    return '';
};

export default validateASCII;
